module.exports = __webpack_public_path__ + "img/EE11315936.ef283716.png";